import { createSlice } from '@reduxjs/toolkit';

export const selectedTemplateSlice = createSlice({
	name: 'selectedTemplate',
	initialState: {
		value: {
			// 'HeaderDesktop': 1
		},
	},
	reducers: {
		setTemplate: (state, action) => {
			state.value = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setTemplate } = selectedTemplateSlice.actions;
// export const template = state => state.selectedTemplate.value
export const templateComponents = (state) => state.selectedTemplate.value;

export default selectedTemplateSlice.reducer;
